import { message } from 'antd'
import { api } from '@/shared'
import { mismatchActions } from '@/entity'

export const getMismatch = ({onSuccess}) => {
	return async (dispatch) => {
		try {
			dispatch(mismatchActions.getMismatchAction())
			const res = await api.mismatch.getMismatch()
			dispatch(mismatchActions.getMismatchActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(mismatchActions.getMismatchActionFail())
		}
	}
}


export const getMismatchXsl = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(mismatchActions.getMismatchXslAction())
			const res = await api.mismatch.getMismatchXsl(data)
			dispatch(mismatchActions.getMismatchXslActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(mismatchActions.getMismatchXslActionFail())
		}
	}
}
